<div>
  <h1>Welcome to the service menu. Please select a service. 😀</h1>
  <h2><a [routerLink]="['/fields']">* Fields</a></h2>
  <h2><a [routerLink]="['/api']">* API</a></h2>
  <h2><a [routerLink]="['/index']">* Indexing</a></h2>
</div>
